import styled from "@emotion/styled";
import type { ReactNode } from "react";

import { Popover } from "../popup";
import { PROPERTY_PANEL_WIDTH, SIDEBAR_COLLAPSED_WIDTH, SIDEBAR_PANEL_WIDTH, zIndexes } from "../utilities";
import { PropertiesPanelPopoverContent } from "./PropertiesPanelPopoverContent";

const StyledPopover = styled(Popover)`
  z-index: ${zIndexes.propertiesPanelPopover};

  .MuiPaper-root {
    overflow: visible;
    border-radius: 8px;
  }
`;

type Props = {
  id: string;
  header?: ReactNode;
  children?: ReactNode;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  className?: string;
  panel?: "properties" | "context";
};

export const PropertiesPanelPopover = ({
  id,
  children,
  header,
  onClose,
  anchorEl,
  className,
  panel = "properties",
}: Props) => {
  const popoverOpen = Boolean(anchorEl);

  const top = anchorEl ? anchorEl.getBoundingClientRect().top + anchorEl.clientHeight / 2 : 0;

  const anchorPosition =
    panel === "properties"
      ? { top, left: window.innerWidth - PROPERTY_PANEL_WIDTH }
      : { top, left: SIDEBAR_PANEL_WIDTH + SIDEBAR_COLLAPSED_WIDTH };

  const transformOrigin = {
    vertical: "center" as const,
    horizontal: panel === "properties" ? ("right" as const) : ("left" as const),
  };

  return (
    <StyledPopover
      id={`popover-${id}`}
      open={popoverOpen}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={anchorPosition}
      transformOrigin={transformOrigin}
    >
      <PropertiesPanelPopoverContent onClose={onClose} header={header} className={className} panel={panel}>
        {children}
      </PropertiesPanelPopoverContent>
    </StyledPopover>
  );
};
